export default __webpack_public_path__ + "static/media/flash-dark.8ba7b05d.svg";